import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  tr: {
    // Common
    appName: 'FlowUpy',
    dashboard: 'Dashboard',
    tasks: 'Görevler',
    courtesyCalls: 'Nezaket Aramaları',
    guestRelations: 'Misafir İlişkileri',
    checklists: 'Kontrol Listeleri',
    projects: 'Projeler',
    sops: 'SOP',
    handover: 'Devir Teslim',
    announcements: 'Duyurular',
    guest: 'Misafir',
    reports: 'Raporlar',
    admin: 'Yönetim',
    settings: 'Ayarlar',
    logout: 'Çıkış',
    login: 'Giriş',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    archive: 'Arşivle',
    create: 'Oluştur',
    search: 'Ara...',
    filter: 'Filtrele',
    all: 'Tümü',
    loading: 'Yükleniyor...',
    noData: 'Veri bulunamadı',
    success: 'Başarılı',
    error: 'Hata',
    notifications: 'Bildirimler',
    markAllRead: 'Tümünü Okundu İşaretle',
    noNotifications: 'Bildirim yok',
    myItems: 'Benim',
    
    // Auth
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    loginTitle: 'FlowUpy\'a Giriş',
    loginSubtitle: 'Profesyonel Görev Yönetimi',
    
    // Dashboard
    welcomeBack: 'Hoş Geldiniz',
    totalTasks: 'Toplam Görev',
    pendingTasks: 'Bekleyen',
    inProgress: 'Devam Eden',
    completed: 'Tamamlanan',
    overdue: 'Gecikmiş',
    pendingCalls: 'Bekleyen Aramalar',
    openComplaints: 'Açık Şikayetler',
    activeStaff: 'Aktif Personel',
    recentTasks: 'Son Görevler',
    quickStats: 'Hızlı İstatistikler',
    unassignedTasks: 'Sahipsiz Görevler',
    claimTask: 'Görevi Üstlen',
    
    // Tasks
    newTask: 'Yeni Görev',
    taskTitle: 'Görev Başlığı',
    description: 'Açıklama',
    location: 'Konum',
    department: 'Departman',
    priority: 'Öncelik',
    assignee: 'Atanan Kişi',
    status: 'Durum',
    dueDate: 'Bitiş Tarihi',
    dueTime: 'Bitiş Saati',
    photos: 'Fotoğraflar',
    pending: 'Bekliyor',
    progress: 'Devam Ediyor',
    low: 'Düşük',
    medium: 'Orta',
    high: 'Yüksek',
    urgent: 'Acil',
    claim: 'Görevi Al',
    start: 'Başlat',
    complete: 'Tamamla',
    
    // Courtesy Calls
    newCall: 'Yeni Arama',
    guestName: 'Misafir Adı',
    roomNumber: 'Oda Numarası',
    callDateTime: 'Arama Tarihi/Saati',
    callType: 'Arama Türü',
    welcome: 'Hoşgeldin',
    duringStay: 'Konaklama Sırası',
    checkout: 'Çıkış',
    callNotes: 'Arama Notları',
    satisfaction: 'Memnuniyet',
    noAnswer: 'Cevap Yok',
    makeCall: 'Ara',
    checkInDate: 'Giriş Tarihi',
    checkOutDate: 'Çıkış Tarihi',
    
    // Guest Relations
    newRelation: 'Yeni Kayıt',
    interactionType: 'Etkileşim Türü',
    complaint: 'Şikayet',
    compliment: 'İltifat',
    feedback: 'Geri Bildirim',
    request: 'Talep',
    category: 'Kategori',
    notes: 'Notlar',
    issueResolved: 'Sorun Çözüldü',
    followUpRequired: 'Takip Gerekli',
    meetingArea: 'Görüşme Alanı',
    
    // Checklists
    newChecklist: 'Yeni Kontrol Listesi',
    checklistName: 'Liste Adı',
    shift: 'Vardiya',
    morning: 'Sabah',
    evening: 'Akşam',
    night: 'Gece',
    general: 'Genel',
    items: 'Maddeler',
    addItem: 'Madde Ekle',
    recurring: 'Tekrarlayan',
    oneTime: 'Tek Seferlik',
    myChecklists: 'Benim Listelerim',
    
    // Projects
    newProject: 'Yeni Proje',
    projectName: 'Proje Adı',
    startDate: 'Başlangıç Tarihi',
    endDate: 'Bitiş Tarihi',
    responsible: 'Sorumlu',
    planning: 'Planlama',
    onHold: 'Beklemede',
    myProjects: 'Benim Projelerim',
    
    // Reports
    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',
    completionRate: 'Tamamlanma Oranı',
    avgSatisfaction: 'Ortalama Memnuniyet',
    departmentPerformance: 'Departman Performansı',
    sendReport: 'Rapor Gönder',
    distributionList: 'Dağıtım Listesi',
    addRecipient: 'Alıcı Ekle',
    email: 'E-posta',
    reportTypes: 'Rapor Türleri',
    
    // Admin
    departments: 'Departmanlar',
    staff: 'Personel',
    newDepartment: 'Yeni Departman',
    newStaff: 'Yeni Personel',
    departmentNameTr: 'Departman Adı (TR)',
    departmentNameEn: 'Departman Adı (EN)',
    staffName: 'Personel Adı',
    role: 'Rol',
    phone: 'Telefon',
    onShift: 'Vardiyada',
    offShift: 'Vardiya Dışı',
    makeAdmin: 'Admin Yap',
    removeAdmin: 'Admin Kaldır',
    searchStaff: 'Personel Ara...',
    
    // Theme
    darkMode: 'Koyu Mod',
    lightMode: 'Açık Mod',
    language: 'Dil',
    turkish: 'Türkçe',
    english: 'English',
    select: 'Seçiniz',
    showArchived: 'Arşivi Göster',
    files: 'Dosyalar',
    addFile: 'Dosya Ekle',
    fileHint: 'PDF, Word, Excel veya görsel ekleyebilirsiniz (maks 15MB)',
    step: 'Adım',
    item: 'Madde',
    editProject: 'Projeyi Düzenle',
    editChecklist: 'Kontrol Listesini Düzenle',
    editTask: 'Görevi Düzenle',
    listType: 'Liste Türü',
    completedShort: 'tamamlandı',
    camera: 'Kamera',
    gallery: 'Galeri',
    photosHint: 'Maksimum 5 fotoğraf, her biri en fazla 5MB',
    unassignedNotify: 'Atanmamış (Departmana Bildirilir)',
    exampleRoom: 'Örn: Oda 101',
    taskCount: 'görev',
    createdLabel: 'Oluşturma',
    completedLabel: 'Tamamlanma',
    createdByLabel: 'Oluşturan',
    completionNoteLabel: 'Tamamlama notu',
    unassignedShort: 'Atanmamış',
    ownerless: 'Sahipsiz',
    archivedLabel: 'Arşivde',
    overdueLabel: 'Gecikmiş',
    myTasksTitle: 'Bana Atanan Görevler',
    onShiftStaff: 'Vardiyadaki Personel',
    topPerformers: 'En Çok Görev Tamamlayan',
    fastestCompleters: 'En Hızlı Görev Tamamlayan',
    noDataYet: 'Henüz veri yok',
    overview: 'Genel Bakış',
    trends: 'Trendler',
    departmentsTab: 'Departmanlar',
    staffTab: 'Personel',
    hourlyAnalysis: 'Saat Analizi',
    reportsSubtitle: 'Detaylı performans analizi ve istatistikler',
    staffMgmtSubtitle: 'Departman ve personel yönetimi',
    changePassword: 'Şifre Değiştir',
    taskTitlesTab: 'Görev Başlıkları',
    aiVisibility: 'AI Visibility',
    lostFound: 'Lost & Found',
  },
  en: {
    // Common
    appName: 'FlowUpy',
    dashboard: 'Dashboard',
    tasks: 'Tasks',
    courtesyCalls: 'Courtesy Calls',
    guestRelations: 'Guest Relations',
    checklists: 'Checklists',
    projects: 'Projects',
    sops: 'SOP',
    handover: 'Handover',
    announcements: 'Announcements',
    guest: 'Guest',
    reports: 'Reports',
    admin: 'Admin',
    settings: 'Settings',
    logout: 'Logout',
    login: 'Login',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    archive: 'Archive',
    create: 'Create',
    search: 'Search...',
    filter: 'Filter',
    all: 'All',
    loading: 'Loading...',
    noData: 'No data found',
    success: 'Success',
    error: 'Error',
    notifications: 'Notifications',
    markAllRead: 'Mark All Read',
    noNotifications: 'No notifications',
    myItems: 'My',
    
    // Auth
    username: 'Username',
    password: 'Password',
    loginTitle: 'Sign in to FlowUpy',
    loginSubtitle: 'Professional Task Management',
    
    // Dashboard
    welcomeBack: 'Welcome Back',
    totalTasks: 'Total Tasks',
    pendingTasks: 'Pending',
    inProgress: 'In Progress',
    completed: 'Completed',
    overdue: 'Overdue',
    pendingCalls: 'Pending Calls',
    openComplaints: 'Open Complaints',
    activeStaff: 'Active Staff',
    recentTasks: 'Recent Tasks',
    quickStats: 'Quick Stats',
    
    // Tasks
    newTask: 'New Task',
    taskTitle: 'Task Title',
    description: 'Description',
    location: 'Location',
    department: 'Department',
    priority: 'Priority',
    assignee: 'Assignee',
    status: 'Status',
    dueDate: 'Due Date',
    dueTime: 'Due Time',
    photos: 'Photos',
    pending: 'Pending',
    progress: 'In Progress',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent',
    claim: 'Claim Task',
    start: 'Start',
    complete: 'Complete',
    
    // Courtesy Calls
    newCall: 'New Call',
    guestName: 'Guest Name',
    roomNumber: 'Room Number',
    callDateTime: 'Call Date/Time',
    callType: 'Call Type',
    welcome: 'Welcome',
    duringStay: 'During Stay',
    checkout: 'Checkout',
    callNotes: 'Call Notes',
    satisfaction: 'Satisfaction',
    noAnswer: 'No Answer',
    makeCall: 'Make Call',
    
    // Guest Relations
    newRelation: 'New Record',
    interactionType: 'Interaction Type',
    complaint: 'Complaint',
    compliment: 'Compliment',
    feedback: 'Feedback',
    request: 'Request',
    category: 'Category',
    notes: 'Notes',
    issueResolved: 'Issue Resolved',
    followUpRequired: 'Follow-up Required',
    meetingArea: 'Meeting Area',
    
    // Checklists
    newChecklist: 'New Checklist',
    checklistName: 'Checklist Name',
    shift: 'Shift',
    morning: 'Morning',
    evening: 'Evening',
    night: 'Night',
    general: 'General',
    items: 'Items',
    addItem: 'Add Item',
    recurring: 'Recurring',
    oneTime: 'One Time',
    myChecklists: 'My Checklists',
    
    // Projects
    newProject: 'New Project',
    projectName: 'Project Name',
    startDate: 'Start Date',
    endDate: 'End Date',
    responsible: 'Responsible',
    planning: 'Planning',
    onHold: 'On Hold',
    myProjects: 'My Projects',
    
    // Reports
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    completionRate: 'Completion Rate',
    avgSatisfaction: 'Avg. Satisfaction',
    departmentPerformance: 'Department Performance',
    sendReport: 'Send Report',
    distributionList: 'Distribution List',
    addRecipient: 'Add Recipient',
    email: 'Email',
    reportTypes: 'Report Types',
    
    // Admin
    departments: 'Departments',
    staff: 'Staff',
    newDepartment: 'New Department',
    newStaff: 'New Staff',
    departmentNameTr: 'Department Name (TR)',
    departmentNameEn: 'Department Name (EN)',
    staffName: 'Staff Name',
    role: 'Role',
    phone: 'Phone',
    onShift: 'On Shift',
    offShift: 'Off Shift',
    makeAdmin: 'Make Admin',
    removeAdmin: 'Remove Admin',
    searchStaff: 'Search Staff...',
    unassignedTasks: 'Unassigned Tasks',
    claimTask: 'Claim Task',
    checkInDate: 'Check-in Date',
    checkOutDate: 'Check-out Date',
    
    // Theme
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    language: 'Language',
    turkish: 'Türkçe',
    english: 'English',
    select: 'Select',
    showArchived: 'Show Archived',
    files: 'Files',
    addFile: 'Add File',
    fileHint: 'You can add PDF, Word, Excel or images (max 15MB)',
    step: 'Step',
    item: 'Item',
    editProject: 'Edit Project',
    editChecklist: 'Edit Checklist',
    editTask: 'Edit Task',
    listType: 'List Type',
    completedShort: 'completed',
    camera: 'Camera',
    gallery: 'Gallery',
    photosHint: 'Maximum 5 photos, up to 5MB each',
    unassignedNotify: 'Unassigned (Notify Department)',
    exampleRoom: 'e.g. Room 101',
    taskCount: 'tasks',
    createdLabel: 'Created',
    completedLabel: 'Completed',
    createdByLabel: 'Created by',
    completionNoteLabel: 'Completion note',
    unassignedShort: 'Unassigned',
    ownerless: 'Ownerless',
    archivedLabel: 'Archived',
    overdueLabel: 'Overdue',
    myTasksTitle: 'Tasks Assigned to Me',
    onShiftStaff: 'On-shift Staff',
    topPerformers: 'Most Tasks Completed',
    fastestCompleters: 'Fastest Completers',
    noDataYet: 'No data yet',
    overview: 'Overview',
    trends: 'Trends',
    departmentsTab: 'Departments',
    staffTab: 'Staff',
    hourlyAnalysis: 'Hourly Analysis',
    reportsSubtitle: 'Detailed performance analysis and statistics',
    staffMgmtSubtitle: 'Department and staff management',
    changePassword: 'Change Password',
    taskTitlesTab: 'Task Titles',
    aiVisibility: 'AI Visibility',
    lostFound: 'Lost & Found',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('hotelflow_lang') || 'tr');

  useEffect(() => {
    localStorage.setItem('hotelflow_lang', language);
  }, [language]);

  const t = (key) => {
    return (translations[language] && translations[language][key]) || translations.tr[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'tr' ? 'en' : 'tr'));
  };

  return (
    <LanguageContext.Provider value={{ language, t, toggleLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
